import React, { FC } from "react";
import { useTranslation } from "react-i18next";

import { EditableSection } from "@/components/EditableSection";
import { Header } from "@/components/Header";
import { Section } from "@/components/Section";
import { Flex } from "@/eworkitComponents";

import { PasswordSection } from "../Password/PasswordSection";

import "../_user-account-settings.scss";

export const PasswordSettings: FC = () => {
  const baseClass = "user-account-settings";
  const { t } = useTranslation("session");

  return (
    <Section padding={["lg"]} borderRadius>
      <Flex className={baseClass} grow={1} direction="column" innerBorder={true} innerPadding="md">
        <Header size="sm" weight="bold" text={t("USERS.SETTINGS.USER_SETTINGS.TAB_NAME.PASSWORD")} />
        <EditableSection>{editableProps => <PasswordSection editableProps={editableProps} />}</EditableSection>
      </Flex>
    </Section>
  );
};
